<div class="fixed">
  <div [class.font-12]="theme === 'tiny'">
    <mat-icon color="primary" [class]="'vertical-align-middle' + theme === 'default' ? 'contact-icon' : 'font-18'">{{ icon }}</mat-icon>
    <ng-container *ngIf="theme === 'default'">
      &nbsp;
    </ng-container>
    <span [class.mat-caption]="theme === 'default'">
      <a [href]="prefix + ':' + data" *ngIf="data; else placeholder">{{ formatted }}</a>
    </span>
  </div>
</div>

<ng-template #placeholder> &ndash; </ng-template>
